module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bd"
  }, [_c('toobarhead', {
    attrs: {
      "showRefresh": false,
      "showBack": true,
      "titleName": '审批详情'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui_floor"
  }, [_c('div', {
    staticClass: "cd-container",
    attrs: {
      "id": "stock-log-timeline"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.contract != -1),
      expression: "this.contract!=-1"
    }],
    attrs: {
      "align": "center"
    }
  }, [_vm._v("合同流程")]), _vm._v(" "), _c('br', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.contract != -1),
      expression: "this.contract!=-1"
    }]
  }), _vm._v(" "), _vm._l((_vm.logList), function(row, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.group == '合同流程'),
        expression: "row.group=='合同流程'"
      }],
      staticClass: "cd-timeline-block"
    }, [_c('div', {
      class: ['cd-timeline-img', (index == 0) ? 'cd-even' : 'cd-odd']
    }), _vm._v(" "), _c('div', {
      staticClass: "cd-timeline-content"
    }, [_c('p', [_vm._v("【" + _vm._s(row.group) + "】-【" + _vm._s(row.flowActionLabel) + "】")]), _vm._v(" "), _c('p', [_vm._v(" 操作人：" + _vm._s(row.userName) + " ")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.resultLabel && row.resultLabel.length > 0),
        expression: "row.resultLabel && row.resultLabel.length > 0"
      }]
    }, [_vm._v("审核结果：" + _vm._s(row.resultLabel))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.taskName && row.taskName == 'legal'),
        expression: "row.taskName && row.taskName=='legal'"
      }]
    }, [_vm._v(_vm._s(_vm.legal(row)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(row.createTime))]), _vm._v(" "), _c('p', [_vm._v("详情：")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.comment && row.comment.length > 0),
        expression: "row.comment && row.comment.length > 0"
      }],
      domProps: {
        "innerHTML": _vm._s(row.comment)
      }
    })])])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.seal != -1),
      expression: "this.seal!=-1"
    }],
    attrs: {
      "align": "center"
    }
  }, [_vm._v("其他盖章流程")]), _vm._v(" "), _c('br', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.seal != -1),
      expression: "this.seal!=-1"
    }]
  }), _vm._v(" "), _vm._l((_vm.logList), function(row, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.group == '其他盖章流程'),
        expression: "row.group=='其他盖章流程'"
      }],
      staticClass: "cd-timeline-block"
    }, [_c('div', {
      class: ['cd-timeline-img', (index == 0) ? 'cd-even' : 'cd-odd']
    }), _vm._v(" "), _c('div', {
      staticClass: "cd-timeline-content"
    }, [_c('p', [_vm._v("【" + _vm._s(row.group) + "】-【" + _vm._s(row.flowActionLabel) + "】")]), _vm._v(" "), _c('p', [_vm._v(" 操作人：" + _vm._s(row.userName) + " ")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.resultLabel && row.resultLabel.length > 0),
        expression: "row.resultLabel && row.resultLabel.length > 0"
      }]
    }, [_vm._v("审核结果：" + _vm._s(row.resultLabel))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.taskName && row.taskName == 'legal'),
        expression: "row.taskName && row.taskName=='legal'"
      }]
    }, [_vm._v(_vm._s(_vm.legal(row)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(row.createTime))]), _vm._v(" "), _c('p', [_vm._v("详情：")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.comment && row.comment.length > 0),
        expression: "row.comment && row.comment.length > 0"
      }],
      domProps: {
        "innerHTML": _vm._s(row.comment)
      }
    })])])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.reClassify != -1),
      expression: "this.reClassify!=-1"
    }],
    attrs: {
      "align": "center"
    }
  }, [_vm._v("重新归档流程")]), _vm._v(" "), _c('br', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.reClassify != -1),
      expression: "this.reClassify!=-1"
    }]
  }), _vm._v(" "), _vm._l((_vm.logList), function(row, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.group == '重新归档流程'),
        expression: "row.group=='重新归档流程'"
      }],
      staticClass: "cd-timeline-block"
    }, [_c('div', {
      class: ['cd-timeline-img', (index == 0) ? 'cd-even' : 'cd-odd']
    }), _vm._v(" "), _c('div', {
      staticClass: "cd-timeline-content"
    }, [_c('p', [_vm._v("【" + _vm._s(row.group) + "】-【" + _vm._s(row.flowActionLabel) + "】")]), _vm._v(" "), _c('p', [_vm._v(" 操作人：" + _vm._s(row.userName) + " ")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.resultLabel && row.resultLabel.length > 0),
        expression: "row.resultLabel && row.resultLabel.length > 0"
      }]
    }, [_vm._v("审核结果：" + _vm._s(row.resultLabel))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.taskName && row.taskName == 'legal'),
        expression: "row.taskName && row.taskName=='legal'"
      }]
    }, [_vm._v(_vm._s(_vm.legal(row)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(row.createTime))]), _vm._v(" "), _c('p', [_vm._v("详情：")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.comment && row.comment.length > 0),
        expression: "row.comment && row.comment.length > 0"
      }],
      domProps: {
        "innerHTML": _vm._s(row.comment)
      }
    })])])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.abolish != -1),
      expression: "this.abolish!=-1"
    }],
    attrs: {
      "align": "center"
    }
  }, [_vm._v("废除合同流程")]), _vm._v(" "), _c('br', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.abolish != -1),
      expression: "this.abolish!=-1"
    }]
  }), _vm._v(" "), _vm._l((_vm.logList), function(row, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.group == '废除合同流程'),
        expression: "row.group=='废除合同流程'"
      }],
      staticClass: "cd-timeline-block"
    }, [_c('div', {
      class: ['cd-timeline-img', (index == 0) ? 'cd-even' : 'cd-odd']
    }), _vm._v(" "), _c('div', {
      staticClass: "cd-timeline-content"
    }, [_c('p', [_vm._v("【" + _vm._s(row.group) + "】-【" + _vm._s(row.flowActionLabel) + "】")]), _vm._v(" "), _c('p', [_vm._v(" 操作人：" + _vm._s(row.userName) + " ")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.resultLabel && row.resultLabel.length > 0),
        expression: "row.resultLabel && row.resultLabel.length > 0"
      }]
    }, [_vm._v("审核结果：" + _vm._s(row.resultLabel))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.taskName && row.taskName == 'legal'),
        expression: "row.taskName && row.taskName=='legal'"
      }]
    }, [_vm._v(_vm._s(_vm.legal(row)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(row.createTime))]), _vm._v(" "), _c('p', [_vm._v("详情：")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.comment && row.comment.length > 0),
        expression: "row.comment && row.comment.length > 0"
      }],
      domProps: {
        "innerHTML": _vm._s(row.comment)
      }
    })])])
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f731966a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/log.vue
// module id = 149
// module chunks = 2